<template>
	<div class="w-100">
    <div class="w-100 mb-3" v-for="facility in facilities">
      <div class="w-100">
        <div class="row no-gutters">
          <div class="col-1 align-self-center">
            <img :src="facility.icon" class="w-100">
          </div>
          <div class="col-11 align-self-center">
            <p class="mb-0 body-2-1 d-inline-block align-middle pl-3">{{facility.name}}</p>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>
<script>
  import PopUpBackground from '@/components/dev/PopUpBackground';
	export default{
    components: {
      PopUpBackground
    },
    props:{
      facilities:{
        type: Array,
        default: () => [],
      }
    },
    data() {
      return {
        all_facilities: false,
      }
    },
		methods: {
      
			xScroll(type, id) {
        let content = document.querySelector("#" + id);
          if (type == 'left') {
            // var slideTimer = setInterval(function(){
              content.scrollLeft -= 80;
              // if(content.scrollLeft >= 80){
                  // window.clearInterval(slideTimer);
                // }
            // }, 25)
          }else {
            // var slideTimer = setInterval(function(){
              content.scrollLeft += 80;
              // if(content.scrollLeft >= 80){
                // window.clearInterval(slideTimer);
              // }
            // }, 25)
          }
      },
      toggleFacilities(){
        this.all_facilities = !this.all_facilities
      }
		}
	}
</script>
<style scoped>
@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/facilities.vue